import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { Observable } from "rxjs";

@Injectable()
  
export class CompanyService {
  private base_url = `${environment.API_URL}/companies`;
  private single_url = `${environment.API_URL}/company`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  getCompanies(params) {
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getIncidents(company_id:number) {
    return this.http.get(`${this.single_url}/${company_id}/incidents?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getCompany(company_id) {
    return this.http
      .get(`${this.single_url}/${company_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  autocompleteCompanies(query, is_seller: boolean = false) {
    let params = {
      query: query,
    };
    if (is_seller) {
      Object.assign(params, {is_seller: is_seller ? 1 : 0})
    }
    return this.http
      .post(`${this.base_url}/autocomplete`, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  createCompany(params) {
    //params["token"] = this.token;
    return this.http
      .post(this.single_url, params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response.id) {
          // If the response is an Object with an ID, this means a success
          this.toast.success("Société Ajoutée avec succès.", false, "Société");
        } else {
          this.toast.error(
            "Erreur lors de l'ajout de la Société.",
            false,
            "Société"
          );
        }
        return response;
      });
  }

  deleteCompany(company_id) {
    return this.http
      .delete(`${this.single_url}/${company_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Société Supprimée avec succès.",
            false,
            "Société"
          );
        } else {
          this.toast.error(
            "Erreur lors de la suppression de la Société.",
            false,
            "Société"
          );
        }
      });
  }

  getCompanyContacts(company_id, params) {
    //params["token"] = this.token;
    return this.http
      .post(`${this.single_url}/${company_id}/contacts`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getCompanyDemands(company_id, params) {
    //params["token"] = this.token;
    return this.http
      .post(`${this.single_url}/${company_id}/demands`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  updateCompany(company_id, params) {
    return this.http
      .patch(`${this.single_url}/${company_id}?token=${this.token}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success(
            "Société Mise à jour avec succès.",
            false,
            "Contact"
          );
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de la Société.",
            false,
            "Contact"
          );
        }
      });
  }

  rateCompany(company_id, company_rating) {
    return this.http
      .patch(
        `${this.single_url}/${company_id}/rate?token=${this.token}`,
        {
          rating: company_rating,
        },
        { headers: this.headers }
      )
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  updateFavoriteStatus(companyId: number, isFavorite: boolean): Observable<any> {
    return this.http.put(`${this.single_url}/${companyId}/favorite`, { is_favorite: isFavorite });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/company.service.ts